/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Issue_Type_LabelInputs */

const en_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue type`)
};

const fr_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'incident`)
};

const de_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabetyp`)
};

const it_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di problema`)
};

const ru_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип проблемы`)
};

const es_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de problema`)
};

const zh_cn2_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题类型`)
};

const ja_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題の種類`)
};

const hi_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषय वर्ग`)
};

const pt_pt2_manual_qc_issue_type_label = /** @type {(inputs: Manual_Qc_Issue_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de problema`)
};

/**
* | output |
* | --- |
* | "Issue type" |
*
* @param {Manual_Qc_Issue_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_issue_type_label = /** @type {((inputs?: Manual_Qc_Issue_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Issue_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_issue_type_label(inputs)
	if (locale === "de") return de_manual_qc_issue_type_label(inputs)
	if (locale === "it") return it_manual_qc_issue_type_label(inputs)
	if (locale === "ru") return ru_manual_qc_issue_type_label(inputs)
	if (locale === "es") return es_manual_qc_issue_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_issue_type_label(inputs)
	if (locale === "ja") return ja_manual_qc_issue_type_label(inputs)
	if (locale === "hi") return hi_manual_qc_issue_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_issue_type_label(inputs)
	return en_manual_qc_issue_type_label(inputs)
});